/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import http from './driver';
import { QuizData, QuizTopsData, QuizInvitation, QuizProfile, QuizResponse } from './types/quiz';

export const getTopics = tid => http.get<QuizData>(`/quiz/topics/${tid}`);
export const getTops = (tid, limit) => http.get<QuizTopsData>(`/quiz/tops/${tid}`, { limit });
export const getInvitations = (tid, limit) => http.get<QuizInvitation>(`/quiz/invitations/${tid}`, { limit });
export const getProfile = (tid, key) => http.get<QuizProfile>(`/quiz/profile/${tid}`, { key });
export const putProfile = body => http.put('/quiz/profile', body);
export const postRecords = tid => http.post<QuizResponse>(`/quiz/records/${tid}`);
export const putRecords = (rid, body) => http.put(`/quiz/records/${rid}`, body);
